export default __webpack_public_path__ + "static/media/auth_1.ddea50d2.svg";